import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Box, 
  Container, 
  Paper, 
  Typography, 
  Button,
  Grid,
  Card,
  CardContent,
  Divider
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MainLayout from '../../components/layout/MainLayout';

function PaymentSuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading] = useState(false);
  // const { authState } = useAuth();
  const [payerID, setPayerID] = useState<string | null>(null);
  const [orderID, setOrderID] = useState<string | null>(null);

  useEffect(() => {
    // Extract query parameters from URL
    const params = new URLSearchParams(location.search);
    const payerID = params.get('PayerID');
    const orderID = params.get('token'); // PayPal uses 'token' for orderID in query params
    
    if (payerID) setPayerID(payerID);
    if (orderID) setOrderID(orderID);
    
    // You could optionally verify the payment here by calling your backend
  }, [location.search]);

  const goToDashboard = () => {
    navigate('/dashboard');
  };

  const goToSessions = () => {
    navigate('/sessions');
  };

  return (
    <MainLayout>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <CheckCircleIcon color="success" sx={{ fontSize: 80, mb: 2 }} />
            <Typography variant="h4" component="h1" gutterBottom>
              Payment Successful!
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Thank you for your enrollment in MathWiz League! Your payment has been processed successfully.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Card sx={{ mb: 3, bgcolor: 'success.light', color: 'white' }}>
            <CardContent>
              <Typography variant="h6">What happens next?</Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                You can now access your enrolled sessions from your dashboard. You'll also receive a confirmation email with all the details.
              </Typography>
            </CardContent>
          </Card>

          {(orderID || payerID) && (
            <Box sx={{ mb: 3, bgcolor: 'grey.100', p: 2, borderRadius: 1 }}>
              <Typography variant="subtitle2" gutterBottom>
                Payment Information
              </Typography>
              {orderID && (
                <Typography variant="body2">
                  Order ID: {orderID}
                </Typography>
              )}
              {payerID && (
                <Typography variant="body2">
                  Payer ID: {payerID}
                </Typography>
              )}
            </Box>
          )}

          <Grid container spacing={2} justifyContent="center" sx={{ mt: 3 }}>
            <Grid item>
              <Button 
                variant="contained" 
                color="primary" 
                onClick={goToDashboard}
                disabled={loading}
              >
                Go to Dashboard
              </Button>
            </Grid>
            <Grid item>
              <Button 
                variant="outlined" 
                onClick={goToSessions}
                disabled={loading}
              >
                Browse More Sessions
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </MainLayout>
  );
}

export default PaymentSuccessPage;